import { defineComponent as _defineComponent } from 'vue'
import { HotAtom, NavAtomItem, Pos3D } from '@/sdk'
import { ref, watchEffect } from 'vue'
import Search from '@/views/sys/search/index.vue'
import { Atom, RusltType } from '@/views/sys/search/constant'
import { LocalCoord, useCanFly, useSDK, useTransform } from '@/hook'
import { ui18n } from '@/lang'
import { main } from '@/store/dataset'


export default /*#__PURE__*/_defineComponent({
  __name: 'input',
  props: {
    placeholder: { type: String, required: true },
    valueLabel: { type: String, required: true },
    icon: { type: String, required: true },
    value: { type: null, required: false }
  },
  emits: ["clear", "changeValue"],
  setup(__props: any, { expose: __expose, emit }) {
  __expose();




const dom = ref<HTMLDivElement>()

const hideSearchContent = ref(false)
const showCustom = ref(false)
const customValue = ref('')
const focuHandler = () => {
  showCustom.value = true
  hideSearchContent.value = false
  clearTimeout(timeout)
}

const clickInput = ref(false)
watchEffect(onCleanup => {
  if (dom.value) {
    dom.value.addEventListener('click', ev => {
      const input = ev.target as HTMLInputElement
      clickInput.value = input.tagName.toUpperCase() === 'INPUT'
    })
  }
})
let timeout
const text = ref<any>()
const blurHandler = () => {
  showCustom.value = false
  if (!clickInput.value) {
    timeout = setTimeout(() => {
      customValue.value = ''
    }, 300)
  }
}

const clearHandler = () => {
  customValue.value = ''
  emit('clear')
}
//192.168.0.13:7173/index.html?caseId=610&ip=http://192.168.0.62&laserServicePort=9008&servicePort=8808&testMap&static=&testMap=true&swssUrl=/swss&swkkUrl=swkk&swkkPort=8070#/fuseEdit/path

const sdk = useSDK()
const enterPosition = (item: Atom) => {
  console.log('?', item)
  if (item.type === RusltType.GPS) {
    const coord = useTransform(item.coord, LocalCoord.LOCAL, item.data)
    emit('changeValue', {
      label: `${item.data.x} ${item.data.y}${
        item.data.z ? ' ' + item.data.z : ''
      }`,
      pos: {
        position: coord,
        // datasetId: main.value.id,
        // dataset_location: item.data
      },
      inMap: true
    })
  }
  if (item.type === RusltType.HOT) {
    emit('changeValue', {
      label: item.data.title,
      pos: {
        position: sdk.scene.hotTransform(item.data),
        datasetId: item.data.datasetId,
        dataset_location: item.data.dataset_location
      },
      inMap: true
    })
  } else if (item.type === RusltType.Model) {
    const positions = sdk.getPointByEntity(item.data.id)
    if (positions) {
      emit('changeValue', {
        label: item.data.title,
        pos: {
          position: positions,
          datasetId: null,
          dataset_location: null
        },
        inMap: true
      })
    } else {
      useCanFly(false, ui18n.t('scene.navErr'))
    }
    // emit('changeValue', { pos: item.data.points[0] as Pos3D, inMap: false })
  }

  customValue.value = ''
  hideSearchContent.value = true
}

const __returned__ = { emit, dom, hideSearchContent, showCustom, customValue, focuHandler, clickInput, get timeout() { return timeout }, set timeout(v) { timeout = v }, text, blurHandler, clearHandler, sdk, enterPosition, Search }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})